import React from 'react';
import { useParams } from 'react-router-dom';
import EditEventForm from '../components/EditEventForm';

export const EditEventPage: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();

  return <EditEventForm eventId={eventId} />;
};
